import React from "react";
import { Link } from "react-router-dom";

const Sidebar = () => {
  return (
    <div className="h-screen fixed top-0 left-0 w-64 bg-gray-800 text-white flex flex-col">
      <div className="p-4 text-2xl font-bold text-center">Menu</div>
      <nav className="mt-10 flex-1">
        <ul>
          <li className="px-6 py-2 hover:bg-gray-700">
            <Link to="/Dashboard">Dashboard</Link>
          </li>
          <li className="px-6 py-2 hover:bg-gray-700">
            <Link to="/DataTableList">List Data Table</Link>
          </li>
          <li className="px-6 py-2 hover:bg-gray-700">
            <Link to="/AddJobVacancy">Add New Job Vacancy</Link>
          </li>
          <li className="px-6 py-2 hover:bg-gray-700">
            <Link to="/Profile">Profile</Link>
          </li>
          <li className="px-6 py-2 hover:bg-gray-700">
            <Link to="/ChangePassword">Change Password</Link>
          </li>
          <li className="px-6 py-2 hover:bg-gray-700">
            <Link to="/Logout">Logout</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
